import CheckIcon from '@mui/icons-material/Check';
import { Card, Grid, Avatar, Box, Tooltip, Badge } from '@mui/material';
import {
  WsColors,
  ActiveJob,
  WsTypography,
  WsTypoColors,
  WsTypoVariants,
  formateDateForNewSubmission,
  timeSince,
} from 'wisestep-base';

export interface JobsCardProps {
  title: string;
  jobCode: string;
  lastUpdated: string;
  onSelect?: () => void;
  onDeSelect?: () => void;
  isSelected: boolean;
  isClosed?: boolean;
  updatedText?: string;
}

const JobsCard = ({
  title,
  jobCode,
  lastUpdated,
  onSelect = () => {},
  onDeSelect = () => {},
  isSelected,
  isClosed = false,
  updatedText = 'lastUpdated :',
}: JobsCardProps) => {
  return (
    <Badge
      badgeContent={
        <Avatar sx={{ bgcolor: WsColors.TheBlues500, width: 24, height: 24 }}>
          <CheckIcon fontSize="small" />
        </Avatar>
      }
      invisible={!isSelected}
      sx={{ width: '100%', font: '8px' }}
    >
      <Card
        sx={{
          position: 'relative',
          width: '100%',
          border: 'solid 1px',
          borderColor: isSelected ? WsColors.TheBlues200 : WsColors.BorderGrey,
        }}
        onClick={isSelected ? onDeSelect : onSelect}
      >
        <Grid
          container
          py={2}
          px={1.5}
          sx={{
            backgroundColor: isSelected ? WsColors.TheBlue75 : WsColors.White,
            width: '100%',
            position: 'relative',
          }}
          rowSpacing={2}
        >
          <Grid item xs={12} gap={0.5} alignItems="center">
            <Grid container sx={{ width: '100%' }} wrap="nowrap" justifyContent="space-between">
              <Box display="flex" alignItems="start" columnGap={0.5} sx={{ mr: 2 }}>
                <ActiveJob
                  color={isClosed ? WsColors.TertiaryShades500 : WsColors.TheBlues400}
                  color2={isClosed ? WsColors.TertiaryShades600 : WsColors.TheBlues500}
                  height={20}
                  width={20}
                />
                <Box>
                  <WsTypography
                    color={WsTypoColors.GREYTEXT}
                    bold={true}
                    // onClick={handleGoBack}
                    cursor="pointer"
                  >
                    {title}
                  </WsTypography>
                  <WsTypography
                    color={WsTypoColors.SENARY}
                    variant={WsTypoVariants.CAPTION}
                    // onClick={handleGoBack}
                    cursor="pointer"
                  >
                    {jobCode}
                  </WsTypography>
                </Box>
              </Box>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Tooltip title={formateDateForNewSubmission(lastUpdated)} placement="bottom">
              <span>
                <WsTypography color={WsTypoColors.GREYTEXT} variant={WsTypoVariants.CAPTION}>
                  {`${updatedText}  ${timeSince(lastUpdated)}`}
                </WsTypography>
              </span>
            </Tooltip>
          </Grid>
        </Grid>
      </Card>
    </Badge>
  );
};
export default JobsCard;
